// extracted by mini-css-extract-plugin
export default {"dialogButtons":"StartConfirmationPopup_dialogButtons__fjj1C","cancelButton":"StartConfirmationPopup_cancelButton__errTn"};